import ConnersQrcode from "./index.vue";
export default ConnersQrcode;

